import axios from 'axios'

export function fetchAllDivisions (params) {
  if (!params) params = {}
  params.page_size = 0
  return axios.get('/api/divisions/', { params })
}
